<div id="titulo">
    <h2>Gestión Petición</h2>
    <span style="flex: 1 1 auto;"></span>
    <h2 id="btnCerrar" mat-flat-button style="margin-right: 20px;" (click)="onClose()" >X</h2>
</div>
<div style="padding: 20px;padding-bottom: 0;padding-top: 0.5em;">
    <h2 style="font-size: 17px">Datos de cliente</h2>
    <div style="display: flex;gap: 10px;margin-top:20px; width:99.7%;">
        <div class="campo" style="width: 20%">
            <label>Tipo</label>
            <input matInput  [(ngModel)]="this.infoPeticion.tipo" readonly>
        </div>
        <div class="campo" style="width: 10%">
            <label>ID</label>
            <input matInput  [(ngModel)]="this.infoPeticion.id" readonly>
        </div>
        <div class="campo" style="width: 12%">
            <label>Fecha Pet.</label>
            <input matInput  [(ngModel)]="this.infoPeticion.fechaPet" readonly>
        </div>
        <div class="campo" style="width: 10%">
          <label>Agente</label>
          <input matInput  [(ngModel)]="this.infoPeticion.agente" readonly >
        </div>
        <div class="campo" style="width: 20%">
          <label>Nombre agente</label>
          <input matInput  [title]="this.infoPeticion.nomAgente" [(ngModel)]="this.infoPeticion.nomAgente" readonly >
        </div>
        <div class="campo" style="width: 12%">
          <label>Teléfono</label>
          <input matInput  [(ngModel)]="this.infoPeticion.telefono" readonly >
        </div>
        <div class="campo" style="width: 20%">
          <label>Email</label>
          <input matInput  [title]="this.infoPeticion.email" [(ngModel)]="this.infoPeticion.email" readonly >
        </div>
        <div class="campo" style="width: 5%">
          <label>Taller</label>
          <input matInput  [(ngModel)]="this.infoPeticion.taller" readonly >
        </div>
        <div class="campo" style="width: 5%">
          <label>Sub.</label>
          <input matInput  [(ngModel)]="this.infoPeticion.subdelega" readonly >
        </div>
        <div class="campo" style="width: 15%">
          <label>Nombre Sub.</label>
          <input matInput  [(ngModel)]="this.infoPeticion.nsubdelega" readonly >
        </div>
    </div>
    <h2 style="font-size: 17px">Datos Servicios</h2>
    <div style="display: flex;gap: 10px;margin-top:20px; width:99.7%;">
      <div class="campo" style="width: 17%">
        <label>Matrícula</label>
        <input matInput  [(ngModel)]="this.infoPeticion.matricula" readonly >
      </div>
      <div class="campo">
        <label>Servicio a realizar</label>
        <input matInput [title]="this.infoPeticion.serRealizar" [(ngModel)]="this.infoPeticion.serRealizar" readonly >
      </div>
      <div class="campo">
        <label>Nombre Cliente</label>
        <input matInput  [title]="this.infoPeticion.nomCliente" [(ngModel)]="this.infoPeticion.nomCliente" readonly >
      </div>
      <div class="campo" style="width: 40%">
        <label>Teléfono Cliente</label>
        <input matInput  [(ngModel)]="this.infoPeticion.telServ" readonly >
      </div>
      <div class="campo">
        <label>Compañía de seguros</label>
        <input matInput  [title]="this.infoPeticion.cia" [(ngModel)]="this.infoPeticion.cia" readonly >
      </div>
      <div class="campo" style="width: 30%">
        <label>Campaña</label>
        <input matInput  [title]="this.infoPeticion.campana" [(ngModel)]="this.infoPeticion.campana" readonly >
      </div>
    </div>
    <div style="display: flex;gap: 10px;margin-top:20px; width:100%;">
        <div class="campo" style="width: 80%">
          <label>Observaciones</label>
          <input matInput  [(ngModel)]="this.infoPeticion.observaciones" readonly >
        </div>
        <div class="campo" style="width: 20%">
            <label>Estado</label>
            <mat-select [(ngModel)]="this.infoPeticion.estado" (ngModelChange)="cambiarEstado($event)">
                <mat-option value="0">0-Pendiente</mat-option>
                <mat-option value="1">1-Gestionado</mat-option>
                <mat-option value="2">2-Completado</mat-option>
                <mat-option value="3">3-Anulado</mat-option>
                <mat-option value="4">R-Rellamada</mat-option>
            </mat-select>
        </div>
    </div>
  <div style="display: flex;gap: 10px;margin-top:20px; width:100%;">
    <div class="campo" *ngIf="showAlert">
      <label style="color: #d56e00">Ojo! No llamar al agente.</label>
    </div>
    <div class="campo" *ngIf="showCliente">
      <label>Cliente prioritario: </label>
      <label style="color: #d56e00">Asegurado mayor de 60 años (tendrá un horario exclusivo en taller sin contacto con otros clientes o un servicio a domicilio.</label>
    </div>
    <div class="campo" *ngIf="showEmail">
      <label>Tipo de e-mail</label>
      <mat-select [(ngModel)]="this.tipoEmail" (ngModelChange)="cambiarEmail($event)">
        <mat-option value="1">1-EMAIL NO CONTESTA</mat-option>
        <mat-option value="2">2-EMAIL TELÉFONO INCORRECTO</mat-option>
        <mat-option value="3">3-EMAIL ANULACIÓN DE SERVICIOS</mat-option>
      </mat-select>
    </div>
    <div class="campo" *ngIf="showAnulacion">
      <label>Motivos Anulación</label>
      <mat-select [(ngModel)]="tipoAnula" (ngModelChange)="cambiarMotivo($event)">
        <mat-option *ngFor="let motivo of arrayAnula; let i = index" [value]="i + 1">
          {{ i + 1 }} - {{ motivo }}
        </mat-option>
    </mat-select>
    </div>
  </div>
</div>
<div id="tablaContainer" *ngIf="comentarios.length>0">
    <div style="position: absolute; right: 9px; top: 509px; z-index: 100;">
      <button mat-icon-button color="primary" (click)="abrirGrande()">
        <img src="assets/icons/fullscreen.svg" style="color: #294634 !important;">
      </button>
    </div>
    <table mat-table [dataSource]="comentarioSource" class="tabla-art" style="min-width: auto; letter-spacing: 0;">
        <ng-container matColumnDef="linea">
            <th mat-header-cell *matHeaderCellDef>Linea</th>
            <td mat-cell *matCellDef="let comentario">{{ comentario.linea.toString() | uppercase}}</td>
        </ng-container>
        <ng-container matColumnDef="fechaHora">
            <th mat-header-cell *matHeaderCellDef>Fecha/Hora</th>
            <td mat-cell *matCellDef="let comentario">{{ comentario.created  | uppercase}}</td>
        </ng-container>
        <ng-container matColumnDef="comentario">
            <th mat-header-cell *matHeaderCellDef>Comentario</th>
            <td mat-cell *matCellDef="let comentario">{{ comentario.obser | uppercase}}</td>
        </ng-container>
        <ng-container matColumnDef="usuario">
            <th mat-header-cell *matHeaderCellDef>Usuario</th>
            <td mat-cell *matCellDef="let comentario">{{ comentario.usuario | uppercase}}</td>
        </ng-container>
      <!-- Render columns -->
        <tr mat-header-row *matHeaderRowDef="['linea', 'fechaHora', 'comentario', 'usuario']"></tr>
        <tr mat-row *matRowDef="let row; columns: ['linea', 'fechaHora', 'comentario', 'usuario']"></tr>
    </table>
</div>
<mat-progress-bar *ngIf="mostrarCarga" mode="indeterminate"></mat-progress-bar>
<mat-dialog-actions align="center"  style="padding: 20px;">
  <a style="width: 15%;" class="btnCCOscuro" mat-flat-button (click)="agregarComentario()" >Nueva línea</a>
  <a style="width: 15%;" *ngIf="showEmailbtn" class="btnCCOscuro" mat-flat-button (click)="enviarEmail()" >Email rellamada</a>
  <a style="width: 15%;" class="btnCCNewOscuro" mat-flat-button (click)="generarHoja()">Generar hoja</a>
</mat-dialog-actions>